import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowMinRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 7,
	viewBox: "0 0 5 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Arrow icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector 211",
			d: "M1.22775 0.75L4 3.5L1.22775 6.25",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgArrowMinRight;
